import { trackEvent } from '@Services/analytics/tracking.service';
import { AuthorizedUserType } from '@Store/slices/authOnboarding/authOnboarding.types';

export const reportPageViewed = (
  origin: string,
  page: string,
  pageName: string,
  query: string,
  authorizedUserType?: AuthorizedUserType
): void => {
  trackEvent('Page Viewed', {
    origin,
    page,
    pageName,
    query,
    ...(authorizedUserType && { role: authorizedUserType }),
  });
};

export const reportWillViewExpireToken = (errorCode: number) => {
  trackEvent('Will View Expire Token', { errorCode });
};

export const reportViewExpireToken = (origin: string) => {
  trackEvent('View Expire Token', { origin });
};

export const reportFormErrorShown = (
  fieldError: string,
  errorCode: number,
  errorMessage: string
) => {
  trackEvent('Form Error Shown', { fieldError, errorCode, errorMessage });
};

export const reportErrorOccurredDuringOnboarding = (
  errorCode: number,
  errorMessage: string,
  origin: string,
  isFromLiliApp: boolean
) => {
  trackEvent('Error Occurred during Onboarding', {
    errorCode,
    errorMessage,
    origin,
    isFromLiliApp,
  });
};
